<template>
  <DashboardMenu />
  <div class="container">
    <div class="row">
      <h1 class="h1">Проверки</h1>
    </div>

    <div style="display: flex; flex-direction: row" class="select-mode-row">
      <p style="margin-right: 15px">Режим просмотра статистики:</p>
      <select v-model="viewModeModel">
        <option value="today">За сегодня</option>
        <option value="yesterday">За вчера</option>
        <option value="week">За неделю</option>
        <option value="lifetime">За все время</option>
      </select>
    </div>

    <div class="stats-columns">
      <div class="stats-column">
        <div class="mdc-card demo-card">
          <div class="mdc-card-wrapper__text-section">
            <!---->
            <div class="card__title">{{ checkStats.requests }}</div>
            <div class="card__subhead">
              Запросов 
              <span v-if="viewMode === 'today'">сегодня</span>
              <span v-else-if="viewMode === 'yesterday'">вчера</span>
              <span v-else-if="viewMode === 'week'">за неделю</span>
              <span v-else>за все время</span>
            </div>
            <!---->
          </div>
        </div>
      </div>
      <div class="stats-column">
        <div class="mdc-card demo-card">
          <div class="mdc-card-wrapper__text-section">
            <!---->
            <div class="card__title">{{ checkStats.valid }}%</div>
            <div class="card__subhead">Процент успешных запросов</div>
            <!---->
          </div>
        </div>
      </div>
      <div class="stats-column">
        <div class="mdc-card demo-card">
          <div class="mdc-card-wrapper__text-section">
            <!---->
            <div class="card__title">{{ checkStats.donors }}</div>
            <div class="card__subhead">Запросов с донорами</div>
            <!---->
          </div>
          <!-- <div class="mdc-card-wrapper__text-section">
            <div class="card__supporting-text">
              Greyhound divisively hello coldly wonderfully marginally far upon
              excluding.
            </div>
          </div> -->
        </div>
      </div>
      <div class="stats-column">
        <div class="mdc-card demo-card">
          <div class="mdc-card-wrapper__text-section">
            <!---->
            <div class="card__title">{{ checkStats.accounts }}</div>
            <div class="card__subhead">Проверено аккаунтов</div>
            <!---->
          </div>
        </div>
      </div>
    </div>

    <div class="mdc-card">
       <div class="mdc-card-wrapper__text-section">
          <div class="card__title">Список проверок</div>
        </div>
      <div class="mdc-data-table">
        <!-- <div class="card">
          <div class="card-body"> -->
        <div class="mdc-data-table__table-container">
          <table class="mdc-data-table__table">
            <thead>
              <tr class="mdc-data-table__header-row">
                <th
                  class="mdc-data-table__header-cell"
                  role="columnheader"
                  scope="col"
                >
                  Id
                </th>
                <th
                  class="mdc-data-table__header-cell"
                  role="columnheader"
                  scope="col"
                >
                  RequestId
                </th>
                <th
                  class="mdc-data-table__header-cell"
                  role="columnheader"
                  scope="col"
                >
                  Донор
                </th>
                <th
                  class="mdc-data-table__header-cell"
                  role="columnheader"
                  scope="col"
                >
                  Кол-во аккаунтов
                </th>
                <th
                  class="mdc-data-table__header-cell"
                  role="columnheader"
                  scope="col"
                >
                  Кол-во Ошибок
                </th>
                <th
                  class="mdc-data-table__header-cell"
                  role="columnheader"
                  scope="col"
                >
                  % Ошибок
                </th>
                <th
                  class="mdc-data-table__header-cell"
                  role="columnheader"
                  scope="col"
                >
                  Тип
                </th>
                <th
                  class="mdc-data-table__header-cell"
                  role="columnheader"
                  scope="col"
                >
                  Время чека
                </th>
                <th
                  class="mdc-data-table__header-cell"
                  role="columnheader"
                  scope="col"
                >
                  Дата
                </th>
                <th
                  class="mdc-data-table__header-cell"
                  role="columnheader"
                  scope="col"
                >
                  Прокси
                </th>
              </tr>
            </thead>
            <tbody class="mdc-data-table__content">
              <tr
               class="mdc-data-table__row"
                v-for="(check, i) in checks"
                :key="i">
                <th class="mdc-data-table__cell" scope="row">{{ check.id }}</th>
                <td class="mdc-data-table__cell">{{ check.requestId }}</td>
                <!-- <td>{{ check.FbAccountId ? '<router-link to="/dashboard/donors/'+check.FbAccountId+'">'+check.FbAccountId+'</router-link>' : '-' }}</td> -->
                <td class="mdc-data-table__cell">
                  <span v-if="!check.FbAccountId">-</span>
                  <router-link
                    v-else
                    :to="'/dashboard/donors/' + check.FbAccountId"
                    >{{ check.FbAccountId }}</router-link
                  >
                </td>
                <td class="mdc-data-table__cell">{{ check.accounts }}</td>
                <td class="mdc-data-table__cell">{{ check.errors }}</td>
                <td class="mdc-data-table__cell">
                  {{ ((check.errors / check.accounts) * 100).toPrecision(3) }}%
                </td>
                <td class="mdc-data-table__cell">{{ check.type }}</td>
                <td class="mdc-data-table__cell">
                  {{ Number(check.checkTime).toPrecision() }}s
                </td>
                <td class="mdc-data-table__cell">
                  {{ moment(check.createdAt).fromNow() }}
                </td>
                <td class="mdc-data-table__cell">
                  {{ check.proxy ? check.proxy : '-' }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="mdc-data-table__pagination">
          <div class="mdc-data-table__pagination-trailing">
            <div class="mdc-data-table__pagination-navigation">
              <div class="mdc-data-table__pagination-total">
                {{ page == 1 ? 1 : 1 + ((page-1) * 100) }}‑{{ page * 100 }} из {{ totalChecks }}
              </div>

              <button
                class="
                  mdc-icon-button
                  material-icons
                  mdc-data-table__pagination-button
                "
                data-prev-page="true"
                @click="getCustomChecks((i = page - 1))"
              >
                <div class="mdc-button__icon">‹</div>
              </button>
              <div v-for="i in neighborPages" :key="i" class="pagination-link-wrapper">
                <a class="page-link" @click="getCustomChecks(i)">{{ i }}</a>
              </div>
              <button
                class="
                  mdc-icon-button
                  material-icons
                  mdc-data-table__pagination-button
                "
                data-last-page="true"
                @click="getCustomChecks((i = page + 1))"
              >
                <div class="mdc-button__icon">›</div>
              </button>
            </div>
          </div>
        </div>

        <!-- </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import DashboardMenu from '@/components/DashboardMenu.vue';
import moment from 'moment';

export default {
  data() {
    return {
      totalChecks: 0,
      pages: 0,
      page: 1,
      checks: [],
      viewMode: 'today',
      checkStats: {
        requests: 0,
        accounts: 0,
        valid: 0,
        donors: 0
      }
    };
  },

  computed: {
    neighborPages: function() {
      const pageNumber = this.page;
      const forDeletion = [0, this.pages + 1];
      return [pageNumber - 1, pageNumber, pageNumber + 1].filter(
        item => !forDeletion.includes(item)
      );
    },
    viewModeModel: {
      get() {
        return this.viewMode;
      },
      set(newVal) {
        this.viewMode = newVal;
        this.getChecksStats(newVal);
      }
    }
  },
  created: function() {
    this.moment = moment;
  },
  methods: {
    async getChecksStats(period) {
      try {
        const token = localStorage.getItem('adminAuthToken');
        const resp = await this.axios.get('checks/' + period + '/stats', {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        console.log(resp);
        this.checkStats = resp.data;
        // this.pages = parseInt(this.totalChecks / 100);
      } catch (err) {
        // localStorage.removeItem('adminAuthToken')
        // console.log('fail')
        // console.log(err);
      }
    },
    async getTotalChecksCount() {
      try {
        const token = localStorage.getItem('adminAuthToken');
        const resp = await this.axios.get('checks/total/count', {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        // console.log(resp);
        this.totalChecks = resp.data._count.id;
        this.pages = parseInt(this.totalChecks / 100);
      } catch (err) {
        // localStorage.removeItem('adminAuthToken')
        // console.log('fail')
        // console.log(err);
      }
    },
    async getCustomChecks(p) {
      // console.log(this.pages);
      // console.log({ p });
      if (p > 0 && p <= this.pages) {
        try {
          const token = localStorage.getItem('adminAuthToken');
          const resp = await this.axios.get('checks/page/' + p, {
            headers: {
              Authorization: `Bearer ${token}`
            }
          });
          // console.log(resp);
          this.checks = resp.data;
          this.page = p;
        } catch (err) {
          // localStorage.removeItem('adminAuthToken')
          // console.log(err);
        }
      } else {
        // console.log('ignore');
      }
    }
  },
  updated() {
    // console.log('page: ' + this.page);
  },
  mounted() {
    this.getTotalChecksCount().then(() => { this.getCustomChecks(this.page) });

    this.getChecksStats(this.viewMode);
  },
  components: { DashboardMenu }
};
</script>

<style lang="scss" scoped>
@import '../styles/material-components-web.min.css';

.container {
  flex-direction: column;
  width: 1280px;
  max-width: 90%;
  margin: 0 auto;
}

.mdc-data-table__header-cell {
  height: 56px;
  font-weight: bold;
}

.stats-columns {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.stats-column {
  width: 25%;
  padding: 10px;
}

.mdc-card-wrapper__text-section {
  padding: 16px;
}

.card__title {
  font-family: 'Ubuntu', sans-serif;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  font-size: 1.25rem;
  line-height: 2rem;
  font-weight: 500;
  letter-spacing: 0.0125em;
  text-decoration: inherit;
  text-transform: inherit;
}

.card__subhead {
  font-family: 'Ubuntu', sans-serif;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 400;
  letter-spacing: 0.0178571429em;
  text-decoration: inherit;
  text-transform: inherit;
  opacity: 0.6;
}

.card__supporting-text {
  font-family: 'Ubuntu', sans-serif;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 400;
  letter-spacing: 0.0178571429em;
  text-decoration: inherit;
  text-transform: inherit;
  opacity: 0.6;
}

.select-mode-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}

select {
  padding: 8px 12px;
  border: 1px solid #333;
  opacity: 0.6;
  font-size: 0.875rem;
  line-height: 1.25rem;
  letter-spacing: 0.0178571429em;
}

.mdc-data-table__pagination-navigation a {
   font-family: 'Ubuntu', sans-serif;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  font-weight: bold;
  text-decoration: none;
  color: rgba(0, 0, 0, 0.47);
  font-size: 24px;
  cursor: pointer;
  &:hover {
     color: rgba(0, 0, 0, 0.87);
     transition: .3s all ease;
  }
}

.mdc-data-table__pagination-navigation .pagination-link-wrapper {
margin-right: 5px;
width: 48px;
height: 48px;
padding: 12px;
}

.mdc-data-table__pagination-navigation button {
  display: flex;
justify-content: center;
align-items: center;
}
// .danger {
//   background: rgb(240, 128, 128, 0.7);
// }

// .success {
//   background: rgba(144, 238, 144, 0.7);
// }
</style>